import React from "react";
import { Col, Row } from "react-bootstrap";

const Footer = () => {
  return (
    <footer className="pt-5 px-5">
      <h3 className="mb-3" style={{ marginTop: "100px" }}>
        GET IN TOUCH
      </h3>
      <form className="d-flex mb-3">
        <Row>
          <Col lg={6} className="mb-2">
            <input
              type="text"
              placeholder="NAME"
              className="d-block mb-1"
              style={{ width: "100%" }}
              disabled
            />
            <input
              type="text"
              placeholder="EMAIL"
              className="mt-1"
              style={{ width: "100%" }}
              disabled
            />
          </Col>
          <Col lg={6} className="mb-2">
            <textarea
              placeholder="MESSAGE"
              style={{ height: "100%", width: "100%" }}
              disabled
            ></textarea>
          </Col>
        </Row>
      </form>
      <button
        className="red-button mb-5 px-3 py-2"
        onClick={() =>
          alert(
            "Unfortunately, messages can't be sent right now, you can email me instead .. Thank you for your interest"
          )
        }
      >
        SUBMIT
      </button>
      <p>&copy; 2022 - All Rights Reserved</p>
    </footer>
  );
};

export default Footer;
